export const styles = {
    growBox: {
        flexGrow: 1,
    },
    actionMenuButton: {
        color: 'secondary.main !important',
        backgroundColor: 'primary.light',
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    dialogTitle: {
        textAlign: 'center',
    },
    buttonsWrapper: {
        justifyContent: 'center',
    },
};
